import ReactCrop, { Crop } from "react-image-crop";
import "./styles.sass";

import React, { FC, useEffect, useRef, useState } from "react";
import { convertFileToBase64, toDataURL } from "../../../utils";
import { $public, BACKEND } from "../../../http";
import Button from "./GgButton";
import { AddIcon } from "../../../assets/icons";
import Modal from "../../modal/Modal";
import { useModal } from "../../../customHooks/useModal";

interface IFileButton {
  label?: string;
  onChange?: (event: string) => void;
  className?: string;
  stylesType?: "default" | "success" | "delete" | "border" | "round";
  disabled?: boolean;
  icon?: IIcon;
  type?: any;
  value?: string;
  error?: boolean;
  index?: Number | String;
}

interface IIcon {
  leftIcon?: any;
  rightIcon?: any;
}

const FileButton: FC<IFileButton> = ({
  onChange,
  type,
  value,
  error,
  index,
  className,
  label,
  disabled,
}) => {
  const [isLoop, setLoop] = useState<any>();
  const [fileURL, setURLFile] = useState<any>(null);
  const [crop, setCrop] = useState<Crop>();
  const [cropImage, setCropImage] = useState<string>();
  const [oldImage, setOldImage] = useState<any>(undefined);
  const [proportion, setProportion] = useState<any>(type ? type : 1);
  const image = useRef<any>();
  const modal = useModal();

  const handleFileChange = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      setURLFile(URL.createObjectURL(e.target?.files[0]));
      try {
        const uploadedImageBase64 = await convertFileToBase64(
          e.target.files[0]
        );
        // @ts-ignore
        setCropImage(uploadedImageBase64);
        // @ts-ignore
        onChange(uploadedImageBase64);
      } catch (error) {
        console.log("file input error", error);
      }
      modal.openModal();
    }
  };

  function getCroppedImg(dataCrop: Crop) {
    setCrop(dataCrop);
    clearTimeout(isLoop);

    setLoop(
      setTimeout(() => {
        if (typeof crop !== "undefined") {
          const canvas = document.createElement("canvas");
          const scaleX = image.current.naturalWidth / image.current.width;
          const scaleY = image.current.naturalHeight / image.current.height;
          canvas.width = proportion === 1 ? 960 : 1200;
          canvas.height = proportion === 1 ? 960 : 520;
          const ctx = canvas.getContext("2d");

          ctx?.drawImage(
            image.current,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            proportion === 1 ? 960 : 1200,
            proportion === 1 ? 960 : 520
          );
          // @ts-ignore
          setCropImage(ctx?.canvas.toDataURL("image/jpeg", 0.8) ?? "");
          // @ts-ignore
          onChange(ctx?.canvas.toDataURL("image/jpeg", 0.8) ?? "");
        }
      }, 500)
    );
  }

  function selectFile() {
    if (!cropImage) {
      document.getElementById(`imageInputFile-${index}`)?.click();
    }
  }

  function turnProportion() {
    if (typeof proportion === "undefined") {
      setProportion(1);
    } else {
      if (proportion === 1) {
        setProportion(1);
      } else {
        setProportion(2.3);
      }
    }
    setCrop(undefined);
  }

  useEffect(() => {
    turnProportion();
    if (value) {
      if (value.includes("data:image")) {
        setCropImage(value);
        setOldImage(value);
        // @ts-ignore
        onChange(value);
      } else {
        toDataURL($public(value), function (dataUrl: String) {
          // @ts-ignore
          setCropImage(dataUrl);
          setURLFile(dataUrl);
          setOldImage(dataUrl);
          // @ts-ignore
          onChange(dataUrl);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className={`image-loader`}>
      <input
        type="file"
        accept="image/*"
        id={`imageInputFile-${index}`}
        className="input-file"
        onChange={handleFileChange}
        disabled={disabled}
      />
      <div
        className={`btn-workspace ${error ? "error" : ""} ${
          className && className
        }`}
        onClick={selectFile}
      >
        {cropImage ? (
          <div>
            <img src={cropImage} alt="original" className="original" />
            <div
              onClick={() => {
                document.getElementById(`imageInputFile-${index}`)?.click();
                setCrop(undefined);
              }}
              className="edit-icon"
            >
              <img
                src={require("../../../assets/images/edit.png")}
                alt="edit"
                style={{
                  maxWidth: "1.2rem",
                  height: "1.2rem",
                }}
              />
            </div>
          </div>
        ) : (
          // <div
          //   className="add-image"
          //   style={{ display: "flex", width: "100%", justifyContent: "center" }}
          // >
          <Button
            label={label ? label : "Add image"}
            icon={{ leftIcon: <AddIcon size="18" className="icon" /> }}
            stylesType="border"
          />
          // </div>
        )}
      </div>
      <Modal
        show={modal.showModal}
        onClose={() => {
          modal.setModalShow(false);
          setCropImage(oldImage);
        }}
        title="Crop photo"
        showSubmit={Boolean(cropImage)}
        onSubmit={() => modal.setModalShow(false)}
      >
        <ReactCrop crop={crop} aspect={proportion} onChange={getCroppedImg}>
          <img ref={image} src={fileURL} alt="original" className="original" />
        </ReactCrop>
      </Modal>
    </div>
  );
};

export default FileButton;
